import * as React from 'react';
import { NavLink, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Button, Header, Menu } from 'semantic-ui-react';

import { clienteApi, Resultados } from 'src/api';
import { NombrePersonal } from 'src/componentes';
import { Contexto } from 'src/contexto';
import Cursos from './Cursos';
import Resumen from './Resumen';

interface State {
    datos?: Resultados<'cursosQueElAlumnoPuedeInscribir'>;
    infoMatricula?: Resultados<'informacionMatricula'>['infoMatricula'];
}

class Inscribir extends React.Component<RouteComponentProps<{ id: string }>, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {};

    public componentDidMount() {
        this.recargarCursos();
    }

    public render() {
        const { history, match } = this.props;

        if (!this.state.datos) {
            return <Header>Cargando . . .</Header>;
        }

        const nombreAlumno = <NombrePersonal nombre={this.state.datos.alumno.nombre} />;

        return (
            <div>
                <Menu tabular>
                    <Menu.Item>
                        <Button
                            basic
                            icon='arrow left'
                            onClick={() => {
                                history.push('/horarios/inscribir');
                            }}
                        />
                    </Menu.Item>

                    <Menu.Item
                        as={NavLink}
                        to={'/horarios/inscribir/' + match.params.id + '/cursos'}
                        content='Inscripción de cursos'
                    />
                    <Menu.Item
                        as={NavLink}
                        to={'/horarios/inscribir/' + match.params.id + '/resultado'}
                        content='Resumen de la inscripción'
                    />
                </Menu>

                <Switch>
                    <Redirect
                        exact
                        from='/horarios/inscribir/:id'
                        to='/horarios/inscribir/:id/cursos'
                    />
                    <Route
                        path='/horarios/inscribir/:id/cursos'
                        render={() => {
                            const { datos, infoMatricula } = this.state;

                            if (!infoMatricula) return null;

                            return (
                                <Cursos
                                    nombreAlumno={nombreAlumno}
                                    asignaturasContratadas={datos!.asignaturasContratadas}
                                    cursos={datos!.cursos}
                                    infoMatricula={infoMatricula}
                                    inscribir={this.inscribir}
                                    desinscribir={this.desinscribir}
                                />
                            );
                        }}
                    />
                    <Route
                        path='/horarios/inscribir/:id/resultado'
                        render={() => (
                            <Resumen
                                nombreAlumno={nombreAlumno}
                                cursos={this.state.datos!.cursos.filter(
                                    x => x.estado.tipo === 'INSCRITO',
                                )}
                                informacionDeContacto={this.state.infoMatricula}
                            />
                        )}
                    />
                </Switch>
            </div>
        );
    }

    private readonly inscribir = (idCurso: number) => {
        const { id } = this.props.match.params;

        clienteApi
            .ejecutar('inscribirAlumnoEnCurso', { idCurso, idAlumno: id })
            .then(this.recargarCursos)
            .catch(this.context.mostrarModalError);
    };

    private readonly desinscribir = (idCurso: number) => {
        const { id } = this.props.match.params;
        clienteApi
            .ejecutar('desinscribirAlumnoDelCurso', { idCurso, idAlumno: id })
            .then(this.recargarCursos)
            .catch(this.context.mostrarModalError);
    };

    private readonly recargarCursos = () => {
        const { id } = this.props.match.params;
        clienteApi
            .ejecutar('cursosQueElAlumnoPuedeInscribir', id)
            .then(resultados => {
                if (resultados) this.setState({ datos: resultados });
                return resultados.alumno.numeroDeMatricula;
            })
            .then(numeroDeMatricula =>
                clienteApi.ejecutar('informacionMatricula', {
                    numerosDeContrato: numeroDeMatricula,
                }),
            )
            .then(resultados => this.setState({ infoMatricula: resultados.infoMatricula }))
            .catch(this.context.mostrarModalError);
    };
}

export default Inscribir;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/componentes/Inscribir/index.tsx